import { useQuery } from '@tanstack/react-query';
import { useAccount } from 'wagmi';

import useGameDetails from './useGameDetails.js';


export const DUMMY_TOTAL_HIST_LENGTH = -1;

function useHistoryLength() {
  const gameDetails = useGameDetails();
  const account = useAccount();

  const { data: historyLength } = useQuery({
    queryKey: ['historyLength',
      gameDetails.contracts.prediction?._address, gameDetails.wantedChain.id, account?.address],
    queryFn: FetchTotalHistoryLength,
    placeholderData: DUMMY_TOTAL_HIST_LENGTH,
    refetchInterval: 5 * 1000,
    staleTime: 5 * 60 * 1000,
    cacheTime: 12 * 60 * 60 * 1000,
  });


  async function FetchTotalHistoryLength() {
    if (!account?.address || !gameDetails.contracts.prediction)
      return DUMMY_TOTAL_HIST_LENGTH;
    const newLength = await gameDetails.contracts.prediction.methods
      .GetUserRoundsLength(account?.address).call();
    return newLength;
  }

  return historyLength;
};

export default useHistoryLength;
